(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-promoters-images"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  const popup = document.getElementById('accordionPopup');
  const popupBody = popup.querySelector('.popup-body');

  document.querySelectorAll('.accordion-card').forEach(card => {
    card.addEventListener('click', () => {
      const data = card.querySelector('.accordion-popup-data');
      popupBody.innerHTML = data.innerHTML;
      popup.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  const closePopup = () => {
    popup.classList.remove('active');
    document.body.style.overflow = '';
  };

  popup.querySelector('.popup-close').addEventListener('click', closePopup);
  popup.querySelector('.accordion-popup-overlay').addEventListener('click', closePopup);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-promoters"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.image-accordion-section .accordion-item');
  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (!isMobile) {
    items.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        items.forEach((el) => {
          if (el !== item) {
            el.classList.add('hidden');
            el.classList.remove('active');

            // Remove the class when hovering another item
            const promoterImg = el.querySelector('.hovered-promoter-image');
            if (promoterImg) promoterImg.classList.remove('remove-img');
          }
        });

        item.classList.add('active');
        item.classList.remove('hidden');

        // Remove class on hover (in case it was there)
        const promoterImg = item.querySelector('.hovered-promoter-image');
        if (promoterImg) promoterImg.classList.remove('remove-img');
      });

      item.addEventListener('mouseleave', () => {
        items.forEach((el) => {
          el.classList.remove('hidden');
          el.classList.remove('active');

          // Add 'remove-img' class to hovered-promoter-image
          const promoterImg = el.querySelector('.hovered-promoter-image');
        });
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {

  /* Desktop hover */
  if (!window.matchMedia('(max-width: 768px)').matches) {
    const items = document.querySelectorAll('.accordion-item');
    items.forEach(item => {
      item.addEventListener('mouseenter', () => {
        items.forEach(el => el.classList.remove('active'));
        item.classList.add('active');
      });
    });
  }

  /* Mobile popup */
  const popup = document.getElementById('accordionPopup');
  if (!popup || !window.matchMedia('(max-width: 768px)').matches) return;

  const popupHeading = popup.querySelector('.popup-heading');
  const popupBody = popup.querySelector('.popup-body');

  document.querySelectorAll('.read-more-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const item = btn.closest('.accordion-item');
      popupHeading.innerHTML = item.querySelector('.accordion-heading').innerHTML;
      popupBody.innerHTML = item.querySelector('.hovered-promo-content').innerHTML;
      popup.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  popup.querySelector('.popup-close').onclick =
  popup.querySelector('.accordion-popup-overlay').onclick = () => {
    popup.classList.remove('active');
    document.body.style.overflow = '';
  };

});

  } catch(e) { console.error(e); }
})();
})();
